<div id="st-all-videos-all-videos-container" [ngClass]="{'st_common_high_padding gap-4': !is_sub_license, 'gap-0 mt-4': is_sub_license}"
  class="all-videos-container d-flex flex-column">
  <div id="st-all-videos-block" class="d-flex align-items-center"
    [ngClass]="screenWidth <= 1024 && searchBarExpanded ? 'justify-content-end' : 'justify-content-between'">
    <p class="tab-title" *ngIf="screenWidth > 1024 || !searchBarExpanded">{{ isLive ? ('live' | translate) : ('videos' |
      translate) }}</p>

    <!-- Desktop: grouped search + filter bar — matches the events / events-results control bar -->
    <ng-container *ngIf="screenWidth > 1024; else st_all_videos_mobile_search">
      <div id="st-all-videos-search-bar-wrap" class="st-filter-actions-bar-wrap d-flex align-items-center">
        <div class="search-container">
          <div class="inner_search">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.9118 15.8626L9.15447 10.1052C8.69613 10.4836 8.16905 10.7798 7.57322 10.9937C6.97738 11.2076 6.36099 11.3145 5.72402 11.3145C4.15729 11.3145 2.83131 10.772 1.7461 9.6871C0.660892 8.60216 0.118286 7.27653 0.118286 5.71021C0.118286 4.14387 0.660754 2.81775 1.74569 1.73185C2.83063 0.645969 4.15626 0.103027 5.7226 0.103027C7.28893 0.103027 8.61504 0.645634 9.70094 1.73085C10.7868 2.81606 11.3298 4.14203 11.3298 5.70877C11.3298 6.36336 11.2199 6.98857 11.0001 7.5844C10.7804 8.18024 10.4871 8.6985 10.1205 9.13921L15.8778 14.8966L14.9118 15.8626ZM5.72402 9.93955C6.90512 9.93955 7.90552 9.52969 8.72524 8.70998C9.54495 7.89026 9.95481 6.88986 9.95481 5.70877C9.95481 4.52767 9.54495 3.52727 8.72524 2.70755C7.90552 1.88784 6.90512 1.47798 5.72402 1.47798C4.54293 1.47798 3.54253 1.88784 2.72281 2.70755C1.90311 3.52727 1.49326 4.52767 1.49326 5.70877C1.49326 6.88986 1.90311 7.89026 2.72281 8.70998C3.54253 9.52969 4.54293 9.93955 5.72402 9.93955Z"
                fill="currentColor" />
            </svg>
            <input type="text" id="st-all-videos-search-input" class="form-control search-input"
              [placeholder]="'search' | translate"
              [value]="searchQuery"
              (input)="onSearchChange($any($event.target).value)">
          </div>
        </div>
        <button type="button" id="st-all-videos-filter-btn" *ngIf="!isLive"
          class="filter-icon-btn p-links"
          (click)="open_filters()"
          [title]="'filter' | translate"
          [attr.aria-label]="'filter' | translate">
          <svg width="16" height="14" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.1827 15.0163C13.3238 15.0163 12.5979 14.7198 12.0049 14.1268C11.4119 13.5338 11.1154 12.8079 11.1154 11.9491C11.1154 11.0902 11.4119 10.3643 12.0049 9.77129C12.5979 9.17828 13.3238 8.88178 14.1827 8.88178C15.0415 8.88178 15.7674 9.17828 16.3604 9.77129C16.9534 10.3643 17.25 11.0902 17.25 11.9491C17.25 12.8079 16.9534 13.5338 16.3604 14.1268C15.7674 14.7198 15.0415 15.0163 14.1827 15.0163ZM14.1818 13.6414C14.6489 13.6414 15.0479 13.4763 15.3787 13.146C15.7096 12.8158 15.875 12.4171 15.875 11.95C15.875 11.4828 15.7099 11.0838 15.3796 10.753C15.0494 10.4222 14.6507 10.2568 14.1835 10.2568C13.7164 10.2568 13.3174 10.4219 12.9866 10.7521C12.6558 11.0823 12.4903 11.481 12.4903 11.9482C12.4903 12.4153 12.6555 12.8143 12.9857 13.1451C13.3159 13.476 13.7146 13.6414 14.1818 13.6414ZM2.125 12.6365V11.2616H9.10576V12.6365H2.125ZM3.81728 7.11894C2.95846 7.11894 2.23253 6.82243 1.63951 6.22943C1.0465 5.63642 0.75 4.9105 0.75 4.05166C0.75 3.19282 1.0465 2.46689 1.63951 1.87389C2.23253 1.28088 2.95846 0.984375 3.81728 0.984375C4.67612 0.984375 5.40205 1.28088 5.99505 1.87389C6.58806 2.46689 6.88456 3.19282 6.88456 4.05166C6.88456 4.9105 6.58806 5.63642 5.99505 6.22943C5.40205 6.82243 4.67612 7.11894 3.81728 7.11894ZM3.81641 5.74396C4.28356 5.74396 4.68255 5.57885 5.01337 5.24862C5.3442 4.91839 5.50961 4.5197 5.50961 4.05255C5.50961 3.58539 5.34449 3.18639 5.01426 2.85557C4.68404 2.52474 4.28534 2.35933 3.81818 2.35933C3.35103 2.35933 2.95204 2.52445 2.62121 2.85469C2.29039 3.18492 2.12498 3.58361 2.12498 4.05076C2.12498 4.51791 2.29009 4.9169 2.62032 5.24772C2.95055 5.57855 3.34925 5.74396 3.81641 5.74396ZM8.89419 4.73913V3.36418H15.875V4.73913H8.89419Z" />
          </svg>
          @if (appliedVideoFilterCount > 0) {
          <span class="videos-filter-count-badge position-absolute top-0 end-0 fs-8 fw-semibold">{{
            appliedVideoFilterCount }}</span>
          }
        </button>
      </div>
    </ng-container>

    <!-- Mobile: expandable search bar (stupa-common-search-bar handles its own collapse) -->
    <ng-template #st_all_videos_mobile_search>
      <div id="st-all-videos-block-1" class="d-flex gap-2"
        [ngClass]="{'w-100': screenWidth <= 1024 && searchBarExpanded}">
        <stupa-common-search-bar id="st-all-videos-search-bar"
          [searchPlaceholder]="'search' | translate" class="w-100"
          [searchQuery]="searchQuery"
          (searchChange)="onSearchChange($event)"
          [is_expandable]="true"
          (inputExpandedChange)="onSearchBarInputExpanded($event)">
        </stupa-common-search-bar>
      </div>
    </ng-template>
  </div>

  <div id="st-all-videos-block-3" class="d-flex my-3 gap-2" *ngIf="!isLive" [ngClass]="{ 'overflow-x-auto': screenWidth < 600 }">
    @for(item of video_tab_list;track item.id){
    @if(item.keep_header){
    <button type="button" (click)="set_video_type(item)" (keydown.enter)="set_video_type(item)" (keydown.space)="$event.preventDefault(); set_video_type(item)" class="video-tab" [ngClass]="{
    'selected-video-tab': this.selected_video_tab.id == item.id,
    'text-nowrap': screenWidth < 600
  }">
      <p class="fs-12">{{ item.title }}</p>
    </button>
    }
    }
  </div>
  <!-- Loading state for videos -->
  @if (video_loading) {
  <stupa-skeleton-loader id="st-all-videos-loading-container" variant="cards" />
  }

  <!-- Videos content -->
  <div id="st-all-videos-block-2" *ngIf="video_list.length > 0 && !video_loading">
    <stupa-video-common-cards [videos_list]="video_list"
      (video_selected)="Video_data($event)"></stupa-video-common-cards>
    <div id="st-all-videos-block-3-2" *ngIf="isLoading && video_list.length > 0" class="d-flex justify-content-center py-3" aria-live="polite">
      <stupa-skeleton-loader variant="cards" />
    </div>

    
  </div>

  <!-- No videos state -->
  <div id="st-all-videos-no-videos-container" class="d-flex align-items-center justify-content-center flex-column no-videos-container"
    *ngIf="video_list.length === 0 && !video_loading">
    
    
    <div id="st-all-videos-sub-msg" class="sub-msg" *ngIf="isLive">{{'no_ongoing_matches' | translate}}</div>
    <div id="st-all-videos-sub-msg-3" class="sub-msg" *ngIf="!isLive">{{'no_result' | translate}}</div>
  </div>
</div>

<stupa-event-filter *ngIf="sidebar_visible" [events_list]="events_list" [stream_status]="stream_status"
  [selectedStatuses]="selectedStatuses" (eventSelection)="onEventSelection($event.event, $event.index)"
  (categorySelection)="onCategorySelection($event)" (statusSelectionChange)="onCheckboxChange($event)"
  (removeStatusItem)="remove_item($event)" (clear_filters)="clear_filters()" (apply_changes)="apply_filters()"
  [is_video_filter]="true" (closeFilters)="close_filters()"></stupa-event-filter>

<p-toast position="top-right" />